module.exports = __webpack_public_path__ + "img/92176.a5f086af.svg";